import styled from "styled-components";
import { Button, Pagination, Tag } from "antd";
import { tmCardPurple, tmCardPurpleHover } from "./colors";

export const PeopleCardButton = styled(Button)`
  border-radius: 6px;
  background-color: ${tmCardPurple};
  border: none;
  color: #ffffff;

  &:hover {
    background-color: ${tmCardPurpleHover};
    color: #ffffff;
  }

  &:focus,
  &:active {
    background-color: ${tmCardPurpleHover};
    color: #ffffff;
  }
`;

export const StyledPagination = styled(Pagination)`
  .ant-pagination-item {
    border-color: ${tmCardPurple};
    border-radius: 6px;

    a {
      color: ${tmCardPurple};
    }

    &:hover {
      border-color: ${tmCardPurpleHover};

      a {
        color: ${tmCardPurpleHover};
      }
    }
  }

  .ant-pagination-item-link {
    &:hover {
      color: ${tmCardPurpleHover};
    }
  }

  .anticon {
    &:hover {
      color: ${tmCardPurpleHover};
    }
  }
`;

export const PeopleCardTag = styled(Tag)<{ textColor?: string }>`
  border-radius: 4px !important;
  font-weight: 500;
  border: none;
  padding-inline: 8px;
  padding-block: 2px;

  &.ant-tag-has-color {
    color: ${p => p.textColor || "inherit"} !important;
  }
`;
